export default interface SysFile1 {
  id: number;
  isRoundCash5: boolean;
}

export const sysFile1DefaultProps: SysFile1 = {
  id: 0,
  isRoundCash5: false,
};
